// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2029":"file-upload","8404":"smartdoc"}[chunkId] + "." + {"2029":"c5359744","8404":"909e234a"}[chunkId] + ".chunk.css";
};